import { useArgonController } from "context";
import { setMiniSidenav } from "context";
import Sidenav from "examples/Sidenav";
import { CustomDescrypt } from "global/func";
import { useEffect, useState } from "react";
import { decodeToken, isExpired } from "react-jwt";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import adminOpdRoutes from "./adminOpdRoutes";
import logo from "assets/images/logo-buton.png";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import userStore from "store/userStore";
import TahunAnggaran from "../TahunAnggaran";
import StrukturAnggaran from "./StrukturAnggaran";
import AnggaranKas from "./AnggaranKas";
import Perencanaan from "./Perencanaan";
import PaketDak from "./PaketPekerjaan/PaketDak";
import BelanjaModal from "./PaketPekerjaan/BelanjaModal";
import Belanja from "./PaketPekerjaan/Belanja";
import Dashboard2 from "./Dashboard";
import Pendapatan from "./Pendapatan";
import LaporanBelanja from "./LaporanBelanja";
import LaporanPendapatan from "./LaporanPendapatan";
import ProjekStrategis from "./PaketPekerjaan/ProjekStrategis";
import LokasiPekerjaan from "./LokasiPekerjaan";
import UserManual from "./UserManual";
import Profil from "./Profil";

const TemplateOpd = () => {
    const { user, tahunAnggaran, reqCount } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, reqCount: state.reqCount }));
    const logOut = userStore((state) => state.logOut)
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const [decodedUser] = useState(decodeToken(decryptedUser));

    const navigate = useNavigate();
    const location = useLocation();
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, sidenavColor } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    useEffect(() => {
        // console.log(user);
        if (user === null) {
            navigate("/", { replace: true });
        }
        else {
            if (isExpired(decryptedUser)) {
                console.log(isExpired(decryptedUser));
                logOut()
                navigate("/", { replace: true });
            }
            else {
                if (decodedUser.role !== 'admin_opd') {
                    navigate("/", { replace: true });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location, reqCount])

    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };

    return (
        tahunAnggaran === null ?
            <>
                <TahunAnggaran />
            </>
            :
            <>

                <Sidenav
                    color={sidenavColor}
                    brand={logo}
                    brandName="TEPRA Kab. Buton"
                    routes={adminOpdRoutes}
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                />
                <DashboardLayout>
                    <DashboardNavbar homePage='/a-pd' isMini={miniSidenav} user={decodedUser.nama || ''} dinas={decodedUser.nm_pd || ""} loginId={decodedUser.id || ''} />
                    <Routes>
                        <Route path="" element={<Dashboard2 />} />
                        <Route path="perencanaan/*" element={<Perencanaan />} />
                        <Route path="pendapatan/*" element={<Pendapatan />} />
                        <Route path="struktur-anggaran/*" element={<StrukturAnggaran />} />
                        <Route path="anggaran-kas/*" element={<AnggaranKas />} />
                        <Route path="laporan-belanja/*" element={<LaporanBelanja />} />
                        <Route path="laporan-pendapatan/*" element={<LaporanPendapatan />} />
                        <Route path="belanja/*" element={<Belanja />} />
                        <Route path="belanja-modal/*" element={<BelanjaModal />} />
                        <Route path="proyek-strategis/*" element={<ProjekStrategis />} />
                        <Route path="paket-dak/*" element={<PaketDak />} />
                        <Route path="lokasi-pekerjaan/*" element={<LokasiPekerjaan />} />
                        <Route path="buku-panduan/*" element={<UserManual />} />
                        <Route path="profil/*" element={<Profil />} />
                    </Routes>
                </DashboardLayout>
            </>
    )
}

export default TemplateOpd